import React, { ReactElement, useEffect } from "react";
import styled from "styled-components/macro";

const BackgroundsDiv = styled.div`
	position: absolute;
	top: 0%;
	bottom: 0%;
	left: 0%;
	right: 0%;
`;
const Background = styled.div`
	background-image: url("coastal.jpg");
	background-size: cover;
	position: absolute;
	width: 100%;
	height: 100%;
	transition: opacity 1s linear;
`;

const backgrounds = ["coastal.jpg", "glam.jpg", "green.jpg", "modern.jpg", "traditional.jpg"];
const imgs = [];
// Preload images
backgrounds.forEach((background) => {
	const img = new Image();
	img.src = background;
	imgs.push(img);
});

const secondBetweenBackgrounds = 4;
let bgIndex = 0;
const setClass = (div: Element, className: string, enabled: boolean) => {
	if (enabled) div.classList.add(className);
	else div.classList.remove(className);
};

function ChangingBackgrounds(): ReactElement | null {
	useEffect(() => {
		const interval = setInterval(() => {
			bgIndex = (bgIndex + 1) % backgrounds.length;
			document.querySelectorAll(".background").forEach((div, i) => setClass(div, "hidden", i > bgIndex));
		}, secondBetweenBackgrounds * 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<BackgroundsDiv>
			{backgrounds.map((bg, i) => (
				<Background
					key={i}
					className={i !== 0 ? "background hidden" : "background"}
					style={{
						backgroundImage: `url("${backgrounds[i]}")`,
					}}
				/>
			))}
		</BackgroundsDiv>
	);
}

export default ChangingBackgrounds;
